export { Flex } from "./component";
export type {
  FlexAlign,
  FlexDirection,
  FlexGap,
  FlexJustify,
  FlexProps,
  FlexWrap,
} from "./types";
